export default __webpack_public_path__ + "static/media/3838.72947fa6.png";